import React from 'react';

interface ElkoConfigurationProps {
    configuration: {
        BaseUrl?: string;
        Token?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface ElkoConfigurationComponent extends React.FC<ElkoConfigurationProps> {
    configFields: string[];
}

const ElkoConfiguration: ElkoConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.elko.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔑</span>
                    Токен авторизации
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Token || ''}
                        onChange={(e) => onChange('Token', e.target.value)}
                        placeholder="Введите токен"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
ElkoConfiguration.configFields = ['BaseUrl', 'Token'];

export default ElkoConfiguration;
